import { useState, useEffect } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import useScrollLockOnMount from "../Helpers/utils";
import { useGlobalState } from "../contexts/GlobalStateContext";


const LikesModal = ({ post, onClose }) => {
  const [likes, setLikes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMoreLikes, setHasMoreLikes] = useState(true);
  const [isLikesLoading, setIsLikesLoading] = useState(false);
  const [currentLikesPage, setCurrentLikesPage] = useState(1);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const { globalState, setFullScreenPost } = useGlobalState();

  useEffect(() => {
    loadLikes(post.uuid, 1);
  }, [post.uuid]);

  const loadLikes = async (uuid, page) => {
    if (isLikesLoading || !hasMoreLikes) return;

    setIsLikesLoading(true);

    try {
      const response = await fetch(
        `${baseUrl}/php/fetch_likes.php?uuid=${post.uuid}&page=${page}`
      );
      const data = await response.json();

      if (data.status === "success") {
        if (data.likes.length === 0 && page === 1) {
          setLikes([]);
          setHasMoreLikes(false);
        } else {
          setLikes((prevLikes) => [...prevLikes, ...data.likes]);
          if (data.likes.length === 0) setHasMoreLikes(false);
        }
      } else {
        setHasMoreLikes(false);
      }
    } catch (error) {
      console.error("Error fetching likes:", error);
      setHasMoreLikes(false);
    } finally {
      setLoading(false);
      setIsLikesLoading(false);
    }
  };

  const handleScroll = async (event) => {
    const { scrollTop, scrollHeight, clientHeight } = event.target;
    if (
      scrollTop + clientHeight >= scrollHeight - 50 &&
      !isLikesLoading &&
      hasMoreLikes
    ) {
      const nextPage = currentLikesPage + 1;
      setCurrentLikesPage(nextPage);
      await loadLikes(post.uuid, nextPage);
    }
  };

  useScrollLockOnMount();


  const modalContent = (
    <div id="likes-modal" className="modal" style={{ display: "block" }}>
      <div className="UM-content">
        <div id="likes-header" style={{ backgroundColor: post.theme || "#333" }}>
          <span id="modal-title" style={{ color: post.text_bg || "white" }}>Likes</span>
          <span className="close" style={{ backgroundColor: post.theme || "#333", color: post.text_bg }} onClick={onClose}>
            &times;
          </span>
        </div>
        <div
          id="UM-section"
          className="modal-body"
          onScroll={handleScroll}
        >
          {loading ? (
            <p>Loading...</p>
          ) : likes.length === 0 ? (
            <p>Be the first one to like this.</p>
          ) : (
            likes.map((like) => (
              <div key={like.actor_id} className="like-item">
                <Link
                  to={`/@${encodeURIComponent(like.actor_username)}`}
                  style={{
                    textDecoration: "none",
                    display: "flex",
                    alignItems: "center",
                  }}
                  onClick={() => setFullScreenPost(null)}
                >

                  <img
                    src={`/profile_pics_icons/${like.actor_id}.jpg?v=${Date.now()}`}
                    alt={`${like.actor_fullName}'s profile`}
                    style={{
                      width: "42px",
                      height: "42px",
                      borderRadius: "50%",
                    }}
                  />
                  <span>{like.actor_fullName}</span>
                </Link>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};

export default LikesModal;
